import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ThankYou from './pages/ThankYou';
import RedirectComponent from './components/RedirectComponent';

function App() {
  return (
    <Router>
      <div className="relative min-h-screen text-white overflow-hidden">
        {/* Animated gradient background (matches Home page) */}
        <div className="absolute inset-0 animate-gradient-xy bg-[conic-gradient(at_top_left,_var(--tw-gradient-stops))] from-indigo-700 via-purple-700 to-pink-600 opacity-90"></div>

        {/* Main layout content */}
        <div className="relative z-10 flex flex-col min-h-screen px-4 sm:px-6 py-6">
          {/* Vibrant Header */}
          <header className="w-full text-center text-3xl font-extrabold bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400 bg-clip-text text-transparent tracking-tight drop-shadow-md mb-8">
            Pay | NotReal003
          </header>

          {/* Routing pages */}
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="*" element={<RedirectComponent to="/" />} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;
